import {EntityType, PropertyDefinition, PropertyDefinitionConfig} from '../types';

export const TEMPLATE_PROPERTY_DATE_TIME_REPOSITORY: PropertyDefinitionConfig = {
	id: 'idPropertyDefinitionDateTimeRepository',
	singular: 'Date & Time Field',
};

export const TEMPLATE_PROPERTY_DATE_TIME_TEMPLATE_PROPERTIES: PropertyDefinition[] = [{
	id: 'idPropertyDefinitionDatetimeTemplateTitleProperty',
	parentId: TEMPLATE_PROPERTY_DATE_TIME_REPOSITORY.id,
	type: EntityType.PropertyDefinitionString,
	slug: 'label',
	label: 'Label',
	required: true,
	autoFocus: true,
}, {
	id: 'idPropertyDefinitionDatetimeTemplateSlugProperty',
	parentId: TEMPLATE_PROPERTY_DATE_TIME_REPOSITORY.id,
	type: EntityType.PropertyDefinitionString,
	slug: 'slug',
	label: 'Key',
	required: true,
	disabled: true,
}, {
	id: 'idPropertyDefinitionDatetimeTemplateRequiredProperty',
	parentId: TEMPLATE_PROPERTY_DATE_TIME_REPOSITORY.id,
	type: EntityType.PropertyDefinitionBoolean,
	slug: 'required',
	label: 'Required',
	required: true,
	defaultChecked: true,
}];
